const userBannerEndPoint = {
  getBannerList: {
    url: "/public/banner",
    method: "GET",
  },
};

export default userBannerEndPoint;
